import React from 'react';
import { JobsiteAnnouncement } from 'apollo/generated/client-operations';
import { Announcement } from 'containers/announcements/types';
import { accessStatusDescription } from './constants';

export const announcementTitle = (
  announcement: Announcement,
  maxLength = 50,
): React.ReactElement => {
  const { subject, message } = announcement;
  const subjectMessage = <strong>{subject.substring(0, maxLength)}</strong>;
  const fullTitle =
    subject.length < maxLength ? (
      <>
        {subjectMessage}
        {': '}
        {message.substring(0, maxLength - subject.length - 2)}
      </>
    ) : (
      subjectMessage
    );
  return fullTitle;
};

export const getSiteAccessStatusDescription = (
  announcement: Partial<
    Pick<JobsiteAnnouncement, 'jobsiteAccessStatus' | 'accessWithinDayRange'>
  >,
): string => {
  const { jobsiteAccessStatus, accessWithinDayRange } = announcement;
  const baseDescription = accessStatusDescription[jobsiteAccessStatus];
  if (jobsiteAccessStatus === 'RecentlyOnsite')
    return [
      baseDescription,
      'within the last',
      accessWithinDayRange,
      'days',
    ].join(' ');

  return baseDescription;
};

export const selectedContractorsList = (
  announcement: Partial<Pick<JobsiteAnnouncement, 'contractors'>>,
): string[] =>
  announcement.contractors?.edges?.length
    ? announcement.contractors?.edges.map(
        (edge) => edge?.node?.organization.name,
      )
    : ['All Contractors'];

export const selectedTradesList = (
  announcement: Partial<Pick<JobsiteAnnouncement, 'trades'>>,
): string[] =>
  announcement.trades?.length ? announcement.trades : ['All Trades'];

export const selectedTitlesList = (
  announcement: Partial<Pick<JobsiteAnnouncement, 'titles'>>,
): string[] =>
  announcement.titles?.length ? announcement.titles : ['All Titles'];

export const selectedLanguagesList = (
  announcement: Partial<Pick<JobsiteAnnouncement, 'languages'>>,
): string[] =>
  announcement.languages?.length ? announcement.languages : ['All Languages'];
